/**
 * @fileoverview Shared `sx` helpers for the student "My tasks" submission
 * drawers, so per-drawer styling tweaks live in one place.
 */

/**
 * Tints the legacy FileUpload / GDrive attach triggers teal (platform accent)
 * and compacts the legacy spacing. The "Upload files" trigger is a <label>
 * (ButtonCard htmlFor), so plain `button` selectors miss it; the legacy
 * `.mt-5` (48px) and empty placeholder blocks created a large dead gap
 * between "Upload files" and "Attach from Google Drive".
 */
export const LIGHT_FILE_BUTTONS_SX = {
  '& button, & a[role="button"], & label.new-buttons': {
    backgroundColor: 'var(--mantine-color-teal-0, #e6fcf5)',
    color: 'var(--mantine-color-teal-7, #099268)',
    borderColor: 'transparent',
  },
  '& .files-container .mt-5': {
    marginTop: 12,
  },
  '& .files-container > div:empty': {
    display: 'none',
  },
} as const
